import React, {
  Fragment,
  useState,
  useCallback,
  useRef,
  useContext,
  useEffect
} from "react";
import { InputWrapper, InputCompleteWrapper } from "./styled";

import { AppContext } from "@/Context";

import { contentEditing, contentEditingChange } from "@/common/store/action.js";
const Input = props => {
  const { state, dispatch } = useContext(AppContext);
  const editing = state.editing;
  const fieldType = editing && editing.type;
  const extra = state.extra || {};
  const maxLength = extra.maxLength || 10;
  const editRef = useRef();
  const [fieldValue, setFieldValue] = useState(extra.content);

  useEffect(() => {
    window.input_ref_focus = true;
    editRef && editRef.current && editRef.current.focus();
    setTimeout(() => {
      
      if (editRef && editRef.current) {
        if(typeof editRef.current.selectionStart == "number") {
          editRef.current.focus();
          editRef.current.selectionStart = editRef.current.selectionEnd = editRef.current.value.length
        }else if (typeof editRef.current.createTextRange != "undefined"){
          editRef.current.focus();
          var range = editRef.current.createTextRange();
          range.collapse(false);
          range.select();
        }
      }
    }, 10);
    setFieldValue(extra.content || "");
  }, [editing]);
  window.xfpyh5 = window.xfpyh5 || {};
  const inputBlur = useCallback(() => {
    // if (!fieldValue) {
    //   window.input_ref_focus = true;
    //   editRef && editRef.current && editRef.current.focus();
    //   return window.JsBridge.xfpyappJsBridge.toast(
    //     `请输入${maxLength}以内文字`
    //   );
    // }
    window.input_ref_focus = false;
    dispatch(contentEditing(false));
  }, [fieldValue]);
  window.xfpyh5.pageBlur = () => {
    inputBlur();
  };
  return editing ? (
    <InputWrapper>
      {/* <GlobalStyle /> */}
      <InputCompleteWrapper>
        <div className="words-num">
          {(fieldValue || "").length}/{maxLength}
        </div>
        <div className="confirm-btn"></div>
      </InputCompleteWrapper>
      {fieldType === "textarea" ? (
        <textarea
          ref={editRef}
          onChange={e => {
            setFieldValue(e.target.value);
            AppContext.hook(e.target.value);
            if (e.target.value.length >= maxLength) {
              window.JsBridge.xfpyappJsBridge.toast(
                `输入已达最大${maxLength}个字符`
              );
            }
          }}
          onBlur={inputBlur}
          maxLength={maxLength}
          defaultValue={extra.content}
          placeholder={"请输入" + maxLength + "以内文字"}
        ></textarea>
      ) : (
        <input
          ref={editRef}
          onChange={e => {
            setFieldValue(e.target.value);
            AppContext.hook(e.target.value);
            if (e.target.value.length >= maxLength) {
              window.JsBridge.xfpyappJsBridge.toast(
                `输入已达最大${maxLength}个字符`
              );
            }
          }}
          onBlur={inputBlur}
          maxLength={maxLength}
          defaultValue={extra.content}
          placeholder={"请输入" + maxLength + "以内文字"}
        />
      )}
    </InputWrapper>
  ) : null;
};

export default Input;
